import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class GestionesService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }
  
  agregarGestion(data:any){
    return this.http.post(`${this.baserApiUrl}gestiones/`,data)
  }

  getGestionCliente(nro_documento:any){
    return this.http.get(`${this.baserApiUrl}gestiones/?nro_documento=${nro_documento}`)
  }
}
